import React, {PureComponent} from 'react';
import Icon from '../../Icon';

class DownButton extends PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.move(this.props.index, this.props.index + 1);
    }

    render() {
        return (
            <a onClick={this.handleClick}><Icon icon="arrow-squared-down" /></a>
        );
    }
}

export default DownButton;
